import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import ProductDetails from './pages/ProductDetails';
import Login from './pages/Login';
import ItemsCadastry from './pages/ItemsCadastry';
import Registration from './pages/Registration';
import OrderDetails from './pages/OrderDetails';
import Orders from './pages/Orders';

function Routers() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/products/:id" element={<ProductDetails />} />
      <Route path="/cadastro/itens" element={<ItemsCadastry />} />
      <Route path="/registration" element={<Registration />} />
      <Route path="/meus-pedidos" element={<Orders />} />
      <Route path="/pedido/:id" element={<OrderDetails />} />
    </Routes>
  )
};

export default Routers;
